export default __webpack_public_path__ + "locales/vi/PrivacyPage.json?hash=05355a9d20a6ba7e512a9ca51c2dac9b";